import { SettingsV2 } from '@dixa/messenger-api-payloads';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';

export function getFirstKbIntegrationTranslatedLanguage(
  settings: SettingsV2.Settings,
): MessengerTranslatedLanguage | undefined {
  const translations = getKbIntegrationTranslations(settings);
  return getFirstTranslatedLanguage(translations);
}

const getFirstTranslatedLanguage = (
  translations: Partial<Record<MessengerTranslatedLanguage, string>>,
): MessengerTranslatedLanguage | undefined => {
  return Object.entries(translations)
    .filter(([_langKey, translation]) => Boolean(translation))
    .map(([langKey]) => langKey as MessengerTranslatedLanguage)[0];
};

function getKbIntegrationTranslations(
  settings: SettingsV2.Settings,
): Partial<Record<MessengerTranslatedLanguage, string>> {
  const kbIntegration =
    settings.integrations.knowledge ?? settings.integrations.elevio;

  return kbIntegration?.displayType === 'display-button-for-access-to-articles'
    ? settings.general.findArticles ?? {}
    : kbIntegration?.searchBarPlaceholder ?? {};
}
